import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import Icon from "./Icon.js";
/**
 * A transient message in the corner. `tone` (walk 4, #2268) is OPTIONAL and defaults to
 * "success", so every earlier caller renders exactly as before; "error" swaps the icon and adds
 * `toast--error`, for a result that did not go through ("Only X can do this", "Already done").
 * `durationMs` (walk 4 review fix, PR #2273) is OPTIONAL and defaults to 4000: a longer message
 * that names people (who CAN do something) stays up long enough to read.
 */
export default function Toast({ message, onDismiss, tone = "success", durationMs = 4000, }) {
    useEffect(() => {
        const timer = setTimeout(onDismiss, durationMs);
        return () => clearTimeout(timer);
    }, [onDismiss, durationMs]);
    return (_jsxs("div", { className: tone === "error" ? "toast toast--error" : "toast", role: "status", "aria-live": "polite", children: [_jsx("span", { className: "toast__ic", children: _jsx(Icon, { name: tone === "error" ? "alert-triangle" : "check-circle-2", size: 16 }) }), _jsx("span", { className: "toast__body", children: message })] }));
}
//# sourceMappingURL=Toast.js.map